(function () {
  /**
   * @param {HTMLElement} section
   */
  function finishSection(section) {
    if (typeof gsap === 'undefined') return;

    var media = section.querySelector('.media-block__media');
    var content = section.querySelector('.media-with-content__content');

    if (media) {
      gsap.set(media, { clearProps: 'all' });
    }

    if (content) {
      gsap.set(content, { clearProps: 'all' });
    }

    section.classList.add('inc-mwc--ready');
    section.classList.remove('inc-mwc--pending');
  }

  function showFallback() {
    document.querySelectorAll('.media-with-content.inc-mwc--animate').forEach(function (node) {
      finishSection(/** @type {HTMLElement} */ (node));
    });
  }

  /**
   * @param {HTMLElement} section
   */
  function killSectionTriggers(section) {
    if (typeof ScrollTrigger === 'undefined') return;

    ScrollTrigger.getAll().forEach(function (trigger) {
      if (trigger.trigger && section.contains(trigger.trigger)) {
        trigger.kill();
      }
    });
  }

  function initIncMediaWithContent() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return false;

    gsap.registerPlugin(ScrollTrigger);

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    document.querySelectorAll('.media-with-content.inc-mwc--animate').forEach(function (node) {
      var section = /** @type {HTMLElement} */ (node);

      if (section.dataset.incMwcAnimated === 'true') return;
      section.dataset.incMwcAnimated = 'true';

      var media = section.querySelector('.media-block__media');
      var content = section.querySelector('.media-with-content__content');

      if (!media) {
        finishSection(section);
        return;
      }

      if (reduceMotion) {
        finishSection(section);
        return;
      }

      killSectionTriggers(section);
      section.classList.remove('inc-mwc--ready');
      section.classList.add('inc-mwc--pending');

      var isRight = section.classList.contains('media-with-content--media-right');
      var slideX = isRight ? (isMobile ? 24 : 48) : isMobile ? -24 : -48;
      var blurFilter = isMobile ? 'none' : 'blur(8px)';

      gsap.set(media, {
        autoAlpha: 0,
        scale: 1.06,
        x: slideX,
        filter: blurFilter,
        transformOrigin: '50% 50%'
      });

      if (content) {
        gsap.set(content, { autoAlpha: 0, y: isMobile ? 12 : 20 });
      }

      var entrance = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top 80%',
          once: true
        },
        onComplete: function () {
          finishSection(section);
        }
      });

      entrance.to(media, {
        autoAlpha: 1,
        scale: 1,
        x: 0,
        filter: 'blur(0px)',
        duration: 0.85,
        ease: 'power3.out'
      });

      if (content) {
        entrance.to(
          content,
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.6,
            ease: 'power2.out'
          },
          '-=0.55'
        );
      }
    });

    ScrollTrigger.refresh();
    return true;
  }

  function boot() {
    if (initIncMediaWithContent()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (initIncMediaWithContent() || attempts >= 40) {
        window.clearInterval(timer);
        if (attempts >= 40) showFallback();
      }
    }, 50);
  }

  if (!window.__incMwcBoot) {
    window.__incMwcBoot = boot;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.media-with-content.inc-mwc--animate').forEach(function (node) {
        var section = /** @type {HTMLElement} */ (node);
        delete section.dataset.incMwcAnimated;
      });
      boot();
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var target = /** @type {HTMLElement | null} */ (event.target);
      if (!target) return;

      var section = target.querySelector('.media-with-content.inc-mwc--animate');
      if (!section) return;

      killSectionTriggers(/** @type {HTMLElement} */ (section));
      delete /** @type {HTMLElement} */ (section).dataset.incMwcAnimated;
    });
  } else {
    boot();
  }
})();
